export const TooltipVariants = {
    ALERT: 'alert',
    NEUTRAL: 'neutral',
};
export const TooltipDirections = {
    DOWN: 'down',
    LEFT: 'left',
    RIGHT: 'right',
    UP: 'up',
};
export const TooltipSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
};
